/**
 * Valida que el storeSlug de la URL corresponda al tenant del usuario.
 * Redirige a /store/:storeSlug correcto si no coincide (ej. usuario con otra tienda).
 */
import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import { storePath } from '@/config/routes.config';

interface StoreGuardProps {
  children: React.ReactNode;
}

export function StoreGuard({ children }: StoreGuardProps) {
  const { storeSlug: urlSlug } = useParams<{ storeSlug: string }>();
  const { storeSlug: authSlug, loading, tenantId } = useAuth();

  if (loading) return null;
  if (!tenantId || !authSlug) return <Navigate to="/login" replace />;
  if (!urlSlug) return <Navigate to={storePath(authSlug, '')} replace />;
  if (decodeURIComponent(urlSlug) !== authSlug) {
    return <Navigate to={storePath(authSlug, '')} replace />;
  }
  return <>{children}</>;
}
